<div class="flex items-center w-full" *transloco="let tSettings; read: 'status_configuration'">
    <app-tb-icon
        appTbDragHandler
        icon="drag_indicator"
        class="cursor-pointer"
        [class.pointer-events-none]="dragDisabled()"
        [color]="dragDisabled() ? 'neutral4' : 'textLight'"
    ></app-tb-icon>
    <app-color-picker
        #colorPicker
        class="mt-2"
        [set]="SetType.STATUS"
        [color]="optionGroup().value.color"
        [subtitle]="option().tags + '/' + option().label"
        (colorChange)="optionGroup().controls.color.setValue($event.color)"
    ></app-color-picker>
    <app-tb-input
        class="w-full"
        *transloco="let tCommonErrors; read: 'common_errors'"
        [formControl]="optionGroup().controls.label"
        [prefixIconTemplate]="iconTemplate"
        [suffixIconTemplate]="defaultIcon"
        [errors]="[
            { code: 'required', message: tSettings('incorrect_input') },
            { code: 'pattern', message: tCommonErrors('name_whitespace_input') },
        ]"
    ></app-tb-input>
    <app-tb-menu #tbMenu [template]="menu">
        <app-tb-icon trigger icon="more_vert" class="icon-m"></app-tb-icon>
    </app-tb-menu>
    <ng-template #menu let-containerLayout="containerLayout" let-close="closeFn">
        <app-modal-layout [containerLayout]="containerLayout" (closeModal)="close()">
            <ng-container title>
                {{ tSettings('option_menu') }}
            </ng-container>
            @if (containerLayout === ModalContainer.BottomSheet) {
                <ng-container subtitle>
                    {{ option().tags + '/' + option().label }}
                </ng-container>
            }
            <app-tb-menu-list [containerLayout]="containerLayout" [insideModalLayout]="true">
                @if (template()) {
                    <app-tb-menu-list-item
                        icon="in_home_mode"
                        (click)="defaultChange.emit(); close()"
                    >
                        {{ tSettings('make_default') }}
                    </app-tb-menu-list-item>
                } @else {
                    <app-tb-menu-list-item icon="colors" (click)="colorPicker.open()"
                        >{{ tSettings('set_color') }}
                    </app-tb-menu-list-item>
                    <app-tb-menu-list-item icon="add_reaction" (click)="iconPicker()?.open()"
                        >{{ tSettings('set_icon') }}
                    </app-tb-menu-list-item>
                }

                @if (!dragDisabled() && !isClosed()) {
                    <app-tb-divider></app-tb-divider>

                    <app-tb-menu-list-item (click)="delete.emit()">
                        <app-tb-icon color="red-600" icon="custom_trash" item-icon></app-tb-icon>
                        <span class="text-red-600" item-title>{{ tSettings('delete') }}</span>
                    </app-tb-menu-list-item>
                }
            </app-tb-menu-list>
        </app-modal-layout>
    </ng-template>

    <ng-template #iconTemplate>
        <app-icon-picker
            #iconPicker
            [set]="SetType.STATUS"
            [icon]="optionGroup().value.icon"
            [subtitle]="option().tags + '/' + option().label"
            (iconChange)="updateIcon($event)"
        ></app-icon-picker>
    </ng-template>
    <ng-template #defaultIcon>
        @if (isDefault()) {
            <app-tb-icon [filled]="true" color="primary" icon="in_home_mode"></app-tb-icon>
        }
    </ng-template>
</div>
